import {ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy} from "@angular/router";
import {AuthService} from "@fedeltapointofsale/data-client";

/**
 * Define the reuse strategy for the application. Currently it is reusing all search pages.
 */
export class UserDetachedRouteHandle {
    user: string;
    detachedRouteHandle: DetachedRouteHandle;

    constructor(user: string, detachedRouteHandle: DetachedRouteHandle) {
        this.user = user;
        this.detachedRouteHandle = detachedRouteHandle;
    }
}

export class AppRouteReuseStrategy implements RouteReuseStrategy {

    handlers: Map<String, UserDetachedRouteHandle> = new Map<String, UserDetachedRouteHandle>();

    constructor(private authService: AuthService) {
    }

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        return this.isSearchRoute(route);
    }

    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
        this.handlers.set(route.routeConfig.path, new UserDetachedRouteHandle(this.authService.getLoggedInUserName(), handle));
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        if (route.routeConfig) {
            const userDetachedRouteHandle: UserDetachedRouteHandle = this.handlers.get(route.routeConfig.path);
            if (userDetachedRouteHandle) {
                if (userDetachedRouteHandle.user === this.authService.getLoggedInUserName()) {
                    return true;
                } else {
                    this.handlers.delete(route.routeConfig.path);
                }
            }
        }
        return false;
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
        if (route.routeConfig) {
            const userDetachedRouteHandle: UserDetachedRouteHandle = this.handlers.get(route.routeConfig.path);
            return userDetachedRouteHandle ? userDetachedRouteHandle.detachedRouteHandle : null;
        } else {
            return null;
        }
    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return future.routeConfig === curr.routeConfig;
    }

    isSearchRoute(route: ActivatedRouteSnapshot): boolean {
        return route.routeConfig.path.endsWith("-search");
    }

}
